import { render, staticRenderFns } from "./getLinkModal.vue?vue&type=template&id=14231464&scoped=true&"
import script from "./getLinkModal.vue?vue&type=script&lang=js&"
export * from "./getLinkModal.vue?vue&type=script&lang=js&"
import style0 from "./getLinkModal.vue?vue&type=style&index=0&id=14231464&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14231464",
  null
  
)

export default component.exports